import { PIPELINE_SUBSTEPS_STORAGE_KEY } from './pipeline-substeps-storage-key';

export function writeShowPipelineSubstepsPreference(showSubsteps: boolean): void {
  try {
    window.localStorage.setItem(PIPELINE_SUBSTEPS_STORAGE_KEY, showSubsteps ? 'true' : 'false');
  } catch {
    // Browser privacy settings can disable localStorage; keep the in-memory toggle usable.
  }
}
